import { useEffect, useState } from "react";
import axios from "axios";
import { APP_SERVICES_URL } from "../Constant/constant";
import userSession from "../Constant/auth";

const useSenapiFuelTypes = (siteName) => {
  const { CustID, authHeader } = userSession;
  const [fuelTypes, setFuelTypes] = useState([]);
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(true);
  // eslint-disable-next-line
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${APP_SERVICES_URL}/senapi/${CustID}/fuelTypes?siteName=${encodeURIComponent(siteName)}`, {
          headers: {
            Authorization: authHeader,
          },
        });
        
        if (response.status === 200) {
          setFuelTypes(response.data);
        } else {
          throw new Error("Failed to fetch data");
        }
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [CustID]);

  return { fuelTypes };
};

export default useSenapiFuelTypes;
